export default "/images/photos-grid.png?6aa994deaf443decdf906811ab2fc2cc";